import type { SVGProps } from 'react'
const SvgTwitterLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 7.13c-.8.36-1.68.6-2.6.72a4.55 4.55 0 0 0 2-2.52 9 9 0 0 1-2.87 1.1 4.53 4.53 0 0 0-7.7 4.14c-3.75-.18-7.07-1.99-9.3-4.74a4.55 4.55 0 0 0 1.4 6.07 4.5 4.5 0 0 1-2.05-.57v.06c0 2.2 1.56 4.04 3.62 4.45a4.5 4.5 0 0 1-2.03.08 4.52 4.52 0 0 0 4.21 3.16A9.02 9.02 0 0 1 3 20.96C5 22.25 7.37 23 9.92 23c8.3 0 12.84-6.92 12.84-12.93l-.01-.59A9.2 9.2 0 0 0 25 7.13"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgTwitterLogo
